/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import CheckIcon from 'src/shared/ui/component/icon/CheckIcon';
import styles from './Step.style';

type Props = {
  isActive?: string,
  isCompleted?: boolean,
  isDisabled?: boolean,
  isLastStep?: boolean,
  hasArrow?: boolean,
  stepNumber?: string,
  label: string,
  onClick?: (number) => void,
  stepIndex?: number,
  // Customization
  className?: string,
  btnClassName?: string,
  circleClassName?: string,
  labelClassName?: string,
  separatorColor?: ({}) => void,
  ariaControls?: string,
};

const useStyles = createUseThemeStyles(styles);

const Step = ({
  isActive,
  isCompleted,
  isDisabled,
  isLastStep,
  hasArrow,
  stepNumber,
  stepIndex,
  label,
  onClick,
  // Customization
  className,
  btnClassName,
  circleClassName,
  labelClassName,
  separatorColor,
  ariaControls,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Event Handlers
   |----------------------------------------------------------------------------
   */

  const onClickEvent = () => {
    if (!isDisabled && onClick && typeof stepIndex === 'number') {
      onClick(stepIndex);
    }
  };

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles({
    isActive,
    isCompleted,
    isDisabled,
    isLastStep,
    separatorColor,
  });

  const rootClasses = classNames(className, classes.root);
  const btnClasses = classNames(btnClassName, classes.button);
  const circleClasses = classNames(circleClassName, classes.circle);
  const labelClasses = classNames(labelClassName, classes.title);

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <li className={rootClasses}>
      <button
        className={btnClasses}
        disabled={isDisabled || isActive}
        onClick={onClickEvent}
        aria-controls={ariaControls}
      >
        <div className={circleClasses}>
          {isCompleted && !isActive ? (
            <>
              <CheckIcon className={classes.icon} />
            </>
          ) : (
            <div className={classes.number}>{stepNumber}</div>
          )}
        </div>
        <span className={labelClasses}>{label}</span>
      </button>
      {hasArrow && !isLastStep && <i className={classes.separatorArrow} />}
    </li>
  );
};

export default React.memo<Props>(Step);
